import React, {useState, useCallback} from 'react';
import TagEditor from './TagEditor.js';
import SequenceEdits from './SequenceEdits.js';
import AnnotationEditor from './AnnotationEdit.js';
import { Input } from 'reactstrap';
import '../../../Annotations.scss';

const NAMES = {
    ANNOTATION: 'Annotations',
    TAGS: 'Tags',
    EDITS: 'Edits',
};

export default ({annotationsView}) => {
    if (!annotationsView) {
        return (
            <div>
            </div>
        );
    }

    let links = ["ANNOTATION", "TAGS", "EDITS"];

    return (
        <div>
        <LinkType annotationsView={annotationsView} linkType={links[0]} linkNumber={0}>
          <AnnotationEditor work={annotationsView}/>
        </LinkType>
        <LinkType annotationsView={annotationsView} linkType={links[1]} linkNumber={1}>
          <TagEditor work={annotationsView}/>
        </LinkType>
        <LinkType annotationsView={annotationsView} linkType={links[2]} linkNumber={2}>
          <SequenceEdits work={annotationsView}/>
        </LinkType>
        </div>
    );
};

const LinkType = ({annotationsView, linkNumber, linkType, children}) => {
    let {workNumber} = annotationsView;
    let boxX = 110;
    let x = 210 + workNumber * 250;
    let style = {
        left: boxX + 20  + linkNumber*220
    };

    let points = [
        x, 0, // top of triangle
        boxX + 20 + linkNumber * 220, 80, // bottom left of triangle
        boxX + 220 + linkNumber * 220, 80 // bottom right of triangle
    ];

    console.log('points = ', points, annotationsView);
    return (
        <div>
          <svg
            className={"annotations-svg " + linkType}
            height="80" width="1000">
            <polygon points={points}/>
          </svg>
          <div style={style} className={"annotations-view " + linkType}>
            {children}
          </div>
        </div>
    );
};

